export const COLORS = {
    primary: "#1890ff",
    secondary: "#242166",
    success: "#52c41a",
    warning: "#faad14",
    danger: "#ff4d4f",
    info: "#13c2c2",
    light: "#f0f2f5",
    white: "#ffffff",
    gradient: "linear-gradient(135deg, #1890ff 0%, #242166 100%)",
    gradientReverse: "linear-gradient(135deg, #242166 0%, #1890ff 100%)",
    sinistrePrimary: "#2ECC71",
    sinistreSecondary: "#A8E6CF",
    sinistreSuccess: "#145A32",
    sinistreWarning: "#333333",
    sinistreDanger: "#2ECC71",
    sinistreInfo: "#2ECC71",
    sinistreLight: "#2ECC71",
    sinistreWhite: "#2ECC71",
    sinistreGradient: "linear-gradient(135deg, #2ECC71 0%, #2ECC71 100%)",
    sinistreGradientReverse: "linear-gradient(135deg, #2ECC71 0%, #2ECC71 100%)",
};

export const SINISTER_COLORS = {
    primary: '#2ECC71',        // Vert émeraude
    primaryLight: '#A8E6CF',   // Vert menthe
    primaryDark: '#145A32',    // Vert sapin
    text: '#333333',           // Gris charbon
    background: '#00000e',     // Blanc cassé
    white: '#FFFFFF',
    gray: '#E8E8E8',
    grayDark: '#666666',
    danger: '#E74C3C',
    warning: '#F39C12',
    info: '#3498DB'
};
